import { Component } from '@angular/core';
import { ConsumptionHubService } from '../../services/consumption-hub.service';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-danger-zone',
  templateUrl: './danger-zone.component.html'
})
export class DangerZoneComponent {
  status = '';
  statusClass = '';
  deleting = false;
  expanded = false;

  targetsStatus = '';
  targetsStatusClass = '';
  deletingTargets = false;

  constructor(
    private hub: ConsumptionHubService,
    public config: ConfigService
  ) {}

  toggleExpanded(): void {
    this.expanded = !this.expanded;
  }

  async deleteDataSource(): Promise<void> {
    this.deleting = true;
    this.setStatus('Deleting data source…');

    try {
      const result = await this.hub.deleteDataSource();
      this.setStatus(`Delete succeeded${result?.status ? ` (${result.status})` : ''}.`, 'success');
    } catch (error: any) {
      this.setStatus(`Delete error: ${error.message}`, 'error');
    } finally {
      this.deleting = false;
    }
  }

  async deleteTargets(): Promise<void> {
    this.deletingTargets = true;
    this.setTargetsStatus('Deleting targets…');

    try {
      const result = await this.hub.deleteTargets();
      const message = typeof result?.body === 'string'
        ? result.body
        : `Delete succeeded${result?.status ? ` (${result.status})` : ''}.`;
      this.setTargetsStatus(message, 'success');
    } catch (error: any) {
      this.setTargetsStatus(`Delete error: ${error.message}`, 'error');
    } finally {
      this.deletingTargets = false;
    }
  }

  private setStatus(text: string, type: 'success' | 'error' | '' = ''): void {
    this.status = text;
    switch (type) {
      case 'success': this.statusClass = 'status-ok'; break;
      case 'error': this.statusClass = 'status-error'; break;
      default: this.statusClass = ''; break;
    }
  }

  private setTargetsStatus(text: string, type: 'success' | 'error' | '' = ''): void {
    this.targetsStatus = text;
    switch (type) {
      case 'success': this.targetsStatusClass = 'status-ok'; break;
      case 'error': this.targetsStatusClass = 'status-error'; break;
      default: this.targetsStatusClass = ''; break;
    }
  }
}
